var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{style:(_vm.style),on:{"click":_vm.handleClick}},[_c('svg',{staticClass:"svg",style:(_vm.style),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }